module.exports = __webpack_public_path__ + "img/pic-5.283993e6.png";